'use strict';

angular.module('clientDashboardApp').service('tutorialService', function ($q, $http) {
  function TutorialService() {
  }

  var ttlSettings = {
      pagesVisited: [],
      completedTutorials: [],
      seenFollowUp: false,
      skipPages: [],
      skipAll: false
  };

  TutorialService.prototype.updateTtlSettings = function(settings){
      ttlSettings = settings;
  }


  TutorialService.prototype.getTtlSettings = function(){

    //var deferred = $q.defer();
    //
    //$http
    //  .get(ttlSettings, {
    //    params: params
    //  })
    //  .success(function (data, status, headers, config) {
    //    deferred.resolve(data);
    //  })
    //  .error(function (data, status, headers, config) {
    //    deferred.reject('Error occurred while summary!');
    //  });
    //
    //return deferred.promise;

    return ttlSettings;

  }


  return new TutorialService();

});
